import { render, staticRenderFns } from "./Node.vue?vue&type=template&id=b1a28b80&scoped=true"
import script from "./Node.vue?vue&type=script&lang=ts"
export * from "./Node.vue?vue&type=script&lang=ts"
import style0 from "./Node.vue?vue&type=style&index=0&id=b1a28b80&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b1a28b80",
  null
  
)

export default component.exports